{
  "underConstruction": "Diese View ist gegenwärtig noch in Entwicklung.",
  "global": {
    "close": "Schließen",
    "copy": "Kopieren",
    "debugInformation": "Debug Informationen",
    "more": "Mehr"
  },
  "menu": {
    "login": "Anmelden",
    "logout": "Abmelden",
    "version": "App Version {version}",
    "taskmanagement": "Tasks",
    "scheme": "Schema",
    "supplierAssignment": "Lieferanten SL",
    "dispo": "Dispo",
    "send": "Versand",
    "nonFood": "Non Food",
    "settings": "Einstellungen"
  },
  "modalDialogue": {
    "discardChanges": {
      "headline": "Änderungen verwerfen?",
      "message": "Sollen die Änderungen wirklich verworfen werden?"
    },
    "saveChanges": {
      "headline": "Änderungen speichern?",
      "message": "Sollen die Änderungen gespeichert werden?",
      "messageSchemeEditing": "Möchtest du die am Schema vorgenommenen Änderungen speichern?",
      "messageDispoEditing": "Möchtest du die an der Dispo vorgenommenen Änderungen speichern?"
    }
  },
  "notification": {
    "updateReminder": {
      "header": "Letzte Aktualisierung",
      "content": "Zum letzten Mal um {lastUpdateTime} Uhr aktualisiert. Es könnten Änderungen vorliegen."
    }
  },
  "filter": {
    "applyText": "Anwenden",
    "cancelText": "Abbrechen",
    "emptyDataText": "Keine Daten verfügbar",
    "okText": "Auswählen",
    "noDataText": "Keine Treffer gefunden",
    "selectAllLabel": "Alle auswählen",
    "searchPlaceholder": "Suche...",
    "searchPlaceholderDropDown": "Suchen",
    "mobileFlyInHeadline": "Suche und Filter",
    "removeButtonText": "Alle Filter zurücksetzen",
    "filterGroups": {
      "context": "Kontext",
      "ediError": "Fehlerbeschreibung",
      "ediErrorCategory": "Kategorie",
      "ediErrorDateLabel": "Fehlerdatum",
      "groupName": "Filter",
      "freightWeightLabel": "Frachtart",
      "location": "Standort",
      "loadLocation": "Eintrittspunkt",
      "logisticTypeLabel": "Logistikart",
      "statusInGateway": "Status in Gateway",
      "logLevel": "Ebene",
      "logUser": "Benutzer",
      "messageDate": "Nachrichtendatum",
      "countryLabel": "Empfangsland",
      "supplier": "Lieferant",
      "supplierLocationLabel": "HL-Standort",
      "businessPartnerTypeLabel": "Geschäftspartnertyp",
      "businessPartnerErrorLabel": "Fehler",
      "businessPartnerShortLabel": "Geschäftspartner-Kürzel",
      "weekdayLabel": "Wochentag",
      "weekLabel": "Woche",
      "logisticPlanner": {
        "changeIndicator": "Änderungs-KZ",
        "country": "Land",
        "ian": "IAN",
        "positionStatus": "Positionsstatus",
        "supplier": "Lieferant"
      },
      "change": {
        "dispoWeek": "Dispowoche",
        "changeCategory": "Änderungskategorie",
        "changeSource": "Änderungsquelle",
        "changeDate": "Änderungsdatum",
        "notificationExisting": "Mitteilung vorhanden",
        "timestamp": "Zeitstempel"
      },
      "sendStatus": {
        "sendStatusLabel": "Versandstatus",
        "handedOverLabel": "Übergeben",
        "calledUpLabel": "Abgerufen",
        "notCalledUpLabel": "Nicht abgerufen",
        "notCalledUpReminderLabel": "Nicht abgerufen (Reminder)",
        "remindedLabel": "Erinnert",
        "errorLabel": "Fehler",
        "sentLabel": "Versendet"
      },
      "dispoStatusLabel": "Status",
      "dispoWeek": "Dispowoche",
      "dispoWeekFromLabel": "DW von",
      "dispoWeekUntilLabel": "DW bis",
      "orderDateLabel": "Bestelldatum",
      "promotionalItemLabel": "Aktionsartikel",
      "exceptionLabel": "Ausnahmen",
      "commTypeLabel": "Versandart",
      "sendDateLabel": "Versanddatum",
      "primaryContactLabel": "Primärkontakt",
      "actionStatusLabel": "Aktionsstatus",
      "dispoOrderWarehouseLevel": {
        "warehouseLabel": "Gesellschaft",
        "warehouseShortLabel": "Gesellschaftskürzel",
        "restrictionViolationLabel": "Restriktionsverletzung",
        "hasChangesLabel": "Änderung",
        "deliveryDayLabel": "Anliefertag GES"
      },
      "dispoOrderArticleLevel": {
        "supplierLabel": "Lieferant",
        "supplierLocationLabel": "Verladestandort",
        "ianLabel": "IAN",
        "travelRouteLabel": "Strecke",
        "lorryNoLabel": "LKW Nummer"
      },
      "contextLabel": "Kontext",
      "logLevelLabel": "Ebene",
      "logUserLabel": "Benutzer",
      "categoryLabel": "Kategorie",
      "taskStatusLabel": "Status",
      "taskModeLabel": "Taskart",
      "taskCategoryLabel": "Taskkategorie",
      "notificationLabel": "Mitteilung"
    },
    "autoSuggestFilter": {
      "noResults": "Keine Treffer",
      "typeToSearch": "Zum suchen tippen"
    }
  },
  "button": {
    "add": "Anlegen",
    "addCombiTour": "Kombitour hinzufügen",
    "addDispoWeek": "Dispowoche anlegen",
    "addSupplier": "Lieferant hinzufügen",
    "append": "Hinzufügen",
    "apply": "Anwenden",
    "accept": "Übernehmen",
    "applyAndOpen": "Übernehmen und Öffnen",
    "back": "Zurück",
    "backToBasicData": "Zurück zu Grunddaten",
    "backToOverview": "Zurück zur Übersicht",
    "cancel": "Abbrechen",
    "changes": "Änderungen",
    "changeArticleData": "Artikeldatenänderung",
    "changeCrossdock": "Crossdockänderung",
    "changeQuantity": "Mengenänderung",
    "close": "Schließen",
    "confirm": "Bestätigen",
    "continue": "Weiter",
    "createScheme": "Schema anlegen",
    "delete": "Löschen",
    "discard": "Verwerfen",
    "edit": "Bearbeiten",
    "editDeliveryPlan": "Anlieferplan bearbeiten",
    "execute": "Ausführen",
    "fileUploadButtonText": "Datei hochladen",
    "fileDropText": "oder hier hinziehen",
    "finishOptimizations": "Optimierungen abschließen",
    "forward": "Weiterleiten",
    "import": "Importieren",
    "lorries": "Transportmittel",
    "no": "Nein",
    "next": "Nächster",
    "nextStep": "Nächster Schritt",
    "moveDispoWeeks": "Dispowochenverschiebung",
    "ok": "OK",
    "open": "Öffnen",
    "preview": "Vorschau",
    "previous": "Vorheriger",
    "proceed": "Fortfahren",
    "remove": "Entfernen",
    "resend": "Erneut versenden",
    "reset": "Zurücksetzen",
    "save": "Speichern",
    "schemePreview": "Schemavorschau",
    "send": "Versenden",
    "sendRequestCountry": "Abfrage Land versenden",
    "sendRequestSupplier": "Abfrage LFT versenden",
    "toScheme": "Zum Schema",
    "transferToSchemes": "Auf Schemas übertragen",
    "update": "Aktualisieren",
    "yes": "Ja"
  },
  "messages": {
    "actionSuccessMessage": "\"{action}\" war erfolgreich.",
    "actionPartialSuccessMessage": "\"{action}\" war teilweise erfolgreich.",
    "actionFailedMessage": "\"{action}\" ist fehlgeschlagen.",
    "saveSuccessMessage": "Der Datensatz wurde erfolgreich gespeichert.",
    "saveErrorMessage": "Fehler beim Speichern des neuen Datensatzes.",
    "updateSchedulerErrorMessage": "Zum Aktualisieren darf der Schedulerjob nicht aktiv sein.",
    "updateSchedulerSuccessMessage": "Der Schedulerjob wurde erfolgreich aktualisiert.",
    "updateSuccessMessage": "Die Änderungen wurden erfolgreich gespeichert.",
    "updateErrorMessage": "Fehler beim Speichern der Änderungen.",
    "inputSaveSuccess": "Die Eingabe wurde erfolgreich bearbeitet.",
    "inputSaveError": "Die Eingabe konnte nicht bearbeitet werden.",
    "invalidValue": "Der Wert ist ungültig.",
    "invalidEmail": "Ungültige E-Mail-Adresse.",
    "invalidEmails": "Ungültige E-Mail-Adressen (Komma getrennt).",
    "invalidInteger": "Keine gültige Ganzzahl.",
    "invalidIntegerList": "Keine gültige Liste von Ganzzahlen.",
    "invalidTimeFormat": "Keine gültige Uhrzeit.",
    "invalidBoolean": "Kann nicht als boolscher Wert interpretiert werden.",
    "invalidLength": "Genau {lengthToCheck} Zeichen erforderlich.",
    "invalidMaxLength": "Maximal {lengthToCheck} Zeichen zulässig.",
    "invalidMinLength": "Minimal {lengthToCheck} Zeichen zulässig.",
    "invalidLengthCheckType": "Der angegebene Typ für die Längenprüfung ist ungültig.",
    "invalidNumberOfDigits": "Genau {numDigits} Ziffern erforderlich.",
    "locationInfoConflictMessage": "In einem Anlieferplan existiert mehrfach ein Lieferant mit der gleichen Zusatzinfo Standort."
  },
  "table": {
    "emptyDataText": "Keine Daten verfügbar",
    "filtersNotSet": "Es müssen alle Filter gesetzt sein."
  },
  "tooltips": {
    "logisticTypes": {
      "ultraFresh": "Ultrafrische",
      "fresh": "Kühl",
      "ambient": "Kühltrocken",
      "dry": "Trocken",
      "frozen": "Tiefkühl",
      "direct": "Direktlogistik"
    },
    "dispoStatus": {
      "cre": "Erstellt",
      "check": "Überprüfung erforderlich",
      "rem": "Erinnert",
      "rtd": "Bereit zur Disposition",
      "rto": "Bereit zur Bestellung",
      "wfr": "Warten auf Freigabe",
      "acc": "Freigegeben",
      "ord": "Bestellt",
      "pord": "Teil bestellt",
      "ordch": "Bestelländerung gesendet",
      "rtoch": "Bereit zur Bestelländerung",
      "rtdch": "Bereit zur Dispoänderung",
      "afoch": "Bestelländerung angefragt",
      "del": "Gelöscht",
      "emp": "Leere Dispo"
    },
    "sendStatus": {
      "sent": "Versendet",
      "sent2": "Erneut versendet",
      "delv": "Übergeben",
      "reci": "Abgerufen",
      "nre1": "Nicht abgerufen",
      "nre2": "Erneut nicht abgerufen",
      "remi": "Erinnert",
      "fwtr": "Weitergeleitet an",
      "fwtc": "Weitergeleitet an Land",
      "error": "Fehler"
    },
    "logging": {
      "copy": "Zeile kopieren"
    },
    "tableIcon": {
      "download": "Herunterladen",
      "openGoogleSheet": "Google Sheet öffnen"
    },
    "taskStatus": {
      "1": "Offen",
      "2": "In Bearbeitung",
      "3": "Warten",
      "4": "Geschlossen"
    }
  },
  "userInactivity": {
    "warningTitle": "Inaktivitätswarnung",
    "warningMessage": "Die automatische Abmeldung aufgrund von Inaktivität erfolgt in {timeout} Sekunden.",
    "warningContinue": "Fortfahren"
  },
  "pages": {
    "home": {
      "pageName": "Startseite"
    },
    "taskmanagement": {
      "pageName": "Tasks",
      "buttonCloseTask": "Task schliessen",
      "closeErrorMessage": "Fehler beim Task schliessen.",
      "closeSuccessMessageOneTask": "Task-ID {taskId} erfolgreich geschlossen.",
      "closeSuccessMessageMultipleTasks": "{count} Tasks wurden erfolgreich geschlossen.",
      "fileTransferErrorNotFound": "Der Fehler konnte nicht gefunden werden.",
      "tabNames": {
        "all": "Alles",
        "open": "Offen",
        "done": "Erledigt"
      },
      "table": {
        "tableHeader": "Tasks",
        "taskId": "Task-ID",
        "status": "Status",
        "taskMode": "Taskart",
        "taskCategory": "Taskkategorie",
        "dispoId": "Dispo-ID",
        "logisticType": "Logistikart",
        "country": "Empfangsland",
        "dwFrom": "DW von",
        "dwUntil": "DW bis",
        "created": "Erstellzeitpunkt",
        "closing": "Schließzeitpunkt"
      },
      "closeMultipleTaskModaldialogue": {
        "headline": "{count} Tasks schließen?",
        "closeQuestion": "Sollen die Tasks {taskList} wirklich geschlossen werden?",
        "message": "Füge eine Notiz hinzu, um sie allen Tasks anzuhängen.",
        "notice": "Notiz (Optional)",
        "noticeInitial": "Füge eine Notiz hinzu...",
        "buttonClose": "Task schliessen"
      },
      "sidebar": {
        "taskId": "Task-ID",
        "status": "Status",
        "created": "Erstellzeitpunkt",
        "closing": "Schließzeitpunkt",
        "dispoId": "Dispo-ID",
        "dispoDesc": "Dispobezeichnung",
        "dispoStatus": "Dispostatus",
        "dwFrom": "DW von",
        "dwUntil": "DW bis",
        "logisticType": "Logistikart",
        "country": "Empfangsland",
        "taskCategory": "Taskkategorie",
        "toLink": "Zum Link",
        "details": "Details",
        "notice": "Notiz",
        "add": "Hinzufügen",
        "closeTask": "Task schliessen",
        "releaseToLia": "Dispo freigeben an LIA",
        "order": "Bestellen",
        "closeModaldialogue": {
          "headline": "Task-ID {taskId} schließen?",
          "message": "Möchten Sie eine Notiz hinzufügen?",
          "notice": "Notiz (Optional)",
          "noticeInitial": "Füge eine Notiz hinzu...",
          "buttonClose": "Task schliessen"
        }
      },
      "modal": {
        "messageReleaseToLia": "Dispo wirklich an LIA freigeben?"
      }
    },
    "scheme": {
      "table": {
        "pageName": "Schema",
        "overview": "Übersicht",
        "schemeDesc": "Bezeichnung",
        "freightWeight": "Frachtart",
        "logisticTypeDesc": "Logistikart",
        "country": "Empfangsland",
        "logisticRoute": "Hauptlauf",
        "orderDayName": "Abwicklungsrahmen",
        "handlingForwarder": "Umschlagender Spediteur",
        "mainRouteLocation": "HL Standort",
        "drivingForwarder": "Fahrender Spediteur",
        "changeDate": "Datum letzte Speicherung",
        "newSchema": "Schema anlegen",
        "newDispo": "Dispo anlegen",
        "active": "Aktiv",
        "inactive": "Inaktiv",
        "allDaysSelectable": "Alle Tage auswählbar",
        "newCreation": "Neue Anlage",
        "orderDate": "Bestelldatum",
        "orderTime": "Bestellzeitpunkt",
        "time": "Uhrzeit",
        "dispoWeek": "Dispowoche",
        "newDispoHeadline": "Es sind {selection} Schemen für die Dispo ausgewählt",
        "newDispoSingleSelectionHeadline": "Es ist {selection} Schema für die Dispo ausgewählt",
        "newDispoSaveSuccessMessage": "Dispo erfolgreich erstellt",
        "newDispoSaveSuccessDescription": "Folgende Dispos sind in der Dispoübersicht einsehbar: {dispoIds}. Diese kannst du bei dem Menüpunkt Dispo finden.",
        "newDispoSaveConflictErrorMessage": "Die Dispo konnte aufgrund eines Konflikts nicht erstellt werden. Die gewählte Uhrzeit bzw. der gewählte Wochentag ist nicht zulässig oder für die ausgewählte Dispowoche existiert bereits eine Dispo.",
        "newDispoSaveErrorMessage": "Die Dispo konnte nicht erstellt werden."
      },
      "details": {
        "supplierPreview": "Lieferantenvorschau",
        "basicDataTabName": "Grunddaten",
        "orderDayTabName": "Abwicklungsrahmen",
        "description": "Bezeichnung",
        "freightWeight": "Frachtart",
        "statusInGateway": "Status in Gateway",
        "statusInGatewayLabel": "Aktiv",
        "collectionLogistics": "Sammellogistik",
        "logisticTypeDesc": "Logistikart",
        "receivingCountry": "Empfangsland",
        "basicParameters": {
          "headline": "Grundparameter",
          "tmsTransfer": "TMS-Übertrag",
          "weightDispo": "Gewichtsdispo",
          "usePalletTypeHp": "HP berücksichtigen",
          "lorryFlag": "LKW genau",
          "externalWarehouse": "Außenlager",
          "stackability": "Stapelfähigkeit",
          "stackingFactor": "Stapelfaktor",
          "useGlnFromLexi": "Absender LExI",
          "lexiGlnName": "GLN Name",
          "doAutoExport": "Automatischer Export",
          "doAutoCreate": "Automatische Erstellung",
          "infoTooltipText": {
            "doAutoCreate": "Bei aktiviertem Parameter wird aus dem Schema automatisch eine Dispo gemäß den Vorgaben in den Grundeinstellungen erstellt. Die Voraussetzung für eine automatische Erstellung ist das Vorliegen mindestens einer Dispowoche.",
            "doAutoExport": "Bei aktiviertem Parameter wird eine Dispo gemäß den Vorgaben in den Grundeinstellungen automatisch an LIA übergeben.",
            "tmsTransfer": "Bei aktiviertem Parameter findet beim Bestellversand eine Übertragung an das TMS statt.",
            "useGlnFromLexi": "Bei aktivem Parameter wird bei EDI-Bestellungen die Käufer-GLN von LExI genutzt und auf der Bestell-PDF ein abweichender Header verwendet. Die GLN ist in den fachlichen Parametern definiert und wird über das Dropdown-Menü zugeordnet."
          }
        },
        "sendParameters": {
          "headline": "Versandparameter",
          "autoSendInitOrder": "Automatischer Versand initiale Bestellung",
          "autoSendChangeOne": "Automatischer Versand Änderungsphase 1",
          "infoTooltipText": {
            "autoSendInitOrder": "Bei aktivem Parameter werden vollständige Dispos automatisch Versand.",
            "autoSendChangeOne": "Bei aktivem Parameter werden geänderte Dispos, welche innerhalb der Änderungsphase 1 von LIA an Gateway zurückgestellt werden, automatisch Versand."
          }
        },
        "logisticRoute": {
          "headline": "Hauptlauf",
          "handlingForwarder": "Umschlagender Spediteur",
          "mainRouteLocation": "HL Standort",
          "drivingForwarder": "Fahrender Spediteur",
          "transportRoute": "Transportweg"
        },
        "changeLorryFlagModalDialogue": {
          "headline": "Hinweis",
          "message": "Die von dir durchgeführte Änderung wirkt sich auf alle Routen/Beladekombinationen des Schemas aus! Willst du die Bearbeitung fortsetzen?"
        },
        "suppliersPreviewModalDialogue": {
          "headline": "{schemeDesc}: Lieferanten",
          "openSupplierAssignment": "Lieferantenzuordnung öffnen"
        }
      },
      "create": {
        "pageName": "Schema anlegen",
        "wizardSteps": {
          "wizardBasicData": "Grunddaten",
          "wizardDeliveryBlocks": "Abwicklungsrahmen"
        },
        "planningComponentHeader": "Schema-Inhalte",
        "time": "Zeit",
        "lastCreation": "Datum letzte Erstellung (Soll)",
        "nextCreation": "Datum nächste Erstellung",
        "timePeriod": "Zeitraum",
        "deliveryPlanEntry": "Anlieferplan",
        "routeEntry": "Route",
        "loadingCombinationEntry": "Beladekombination",
        "warehouseLabel": "Gesellschaften",
        "warehouseAction": "Gesellschaft",
        "orderDayAction": "Abwicklungsrahmen",
        "combiTourLabel": "Kombitour",
        "wareHouseEntry": "Anlieferung Gesellschaft",
        "hauler": "Spediteur",
        "supplier": "Lieferant",
        "supplierLocation": "Verladestandort",
        "travelRoute": "Strecke",
        "transportType": "Transportart",
        "minOrderVal": "Mindestabnahme",
        "palletType": "Palettenart",
        "settings": "Einstellungen",
        "parameter": "Parameter",
        "saveSuccessMessageBasicData": "Grunddaten erfolgreich gespeichert.",
        "saveErrorMessageBasicData": "Fehler beim Speichern der Grunddaten.",
        "parameterImportNotificationDescription": "Aufgrund deiner Angaben der Frachtart wurden die Parameter aus dem System importiert. Bitte prüfe die Angaben oder passe diese ggf. an.",
        "cancelCreateScheme": "Beim Abbrechen werden alle bisherigen Eingaben verworfen.",
        "cancelCreateSchemeHeadline": "Anlageprozess abbrechen?",
        "importDefaultSettingsSuccessMessage": "Grundeinstellungen erfolgreich importiert.",
        "importDefaultSettingsDescriptionSuccessMessage": "Aufgrund deiner Angaben in den Grunddaten wurden die Grundeinstellungen aus dem System importiert. Bitte prüfe die Angaben oder passe diese ggf. an.",
        "importDefaultSettingsErrorMessage": "Fehler beim Importieren der Grunddaten.",
        "hauptlauf": "Anlieferung Hauptlauf",
        "zwischenlauf": "Anlieferung Zwischenlauf",
        "zwischenlaufLabel": "Anlieferung ZWL:",
        "zulauf": "Anlieferung Zulauf",
        "zulaufLabel": "Anlieferung ZL:",
        "start": "Start",
        "loadingLocation": "Verladestandort",
        "locationInfo": "Zusatzinfo Standort",
        "lorryCapacity": "Kapazität in TrM",
        "rename": "Bezeichnung bearbeiten"
      },
      "validation": {
        "fieldEmptyErrorMessage": "Feld darf nicht leer sein.",
        "schemeDescValidatorMessage": "Die ersten 5 Zeichen dürfen nur Buchstaben Aa-Zz, Zahlen 0-9, Leerzeichen ' ' , '+' und '-' enthalten.",
        "minOrderValidatorMessage": "Die Eingabe muss größer als 0 und kleiner oder gleich der in der Transportart spezifizierten Mindestabnahme sein.",
        "minSelectedWarehousesMessage": "Für eine Kombitour müssen mindestens 2 Gesellschaften ausgewählt werden.",
        "basicSettingsTimeValidatorMessage": "Ungültiger Zeitwert in Relation zur vorhergehenden Einstellung.",
        "extWhValidatorMessage": "Außenlager können nur zusammen mit dem zugehörigen Hauptlager eingeschlossen werden.",
        "positiveIntegerValidatorMessage": "Die Eingabe muss eine ganze Zahl größer 0 sein."
      },
      "calendar": {
        "deleteEntryConfirmationPrompt": "Soll das Element wirklich gelöscht werden?",
        "deletionLastAbwicklungsrahmenNotPossible": "Es muss mindestens ein Abwicklungsrahmen existieren, deswegen ist eine Löschung nicht möglich."
      },
      "tooltips": {
        "timeOfCreationHeaderText": "Uhrzeit für automatische Dispoerstellung",
        "timeOfCreationContentText": "Daher nicht änderbar."
      },
      "noticeBoard": {
        "pageName": "Mitteilungsboard",
        "table": {
          "header": "Mitteilungen",
          "notice": "Mitteilung",
          "notificationDocument": "Mitteilungsdokument",
          "noticeId": "Mitteilungs-ID",
          "recipientGroup": "Empfängergruppe",
          "logisticType": "Logistikart",
          "country": "Land",
          "schemeId": "Schema-ID",
          "dispoId": "Dispo-ID",
          "sendPeriod": "Versandzeitraum",
          "sendDate": "Versanddatum",
          "sendWithEveryDispo": "Bei jeder Dispo versenden",
          "sendOnChange": "Bei Änderungen versenden",
          "isEdiNotification": "Mitteilung für Parallelversand",
          "createNotice": "Mitteilung anlegen"
        },
        "createNotification": {
          "headerAddNotification": "Mitteilung anlegen",
          "headerEditNotification": "Mitteilung bearbeiten",
          "pdfFile": "PDF-Datei",
          "isEdiNotification": "Mitteilung für Parallelversand",
          "isEdiNotificationToolTip": "Bei aktivem Parameter wird die Mitteilung für die EDI Umstellung vor das MFT Dokument gestellt.",
          "receiverGroup": "Empfängergruppe",
          "receiverGroupToolTip": "Es kann immer nur eine Empfängergruppe ausgewählt werden. Beim Wechsel der Kategorie werden bereits gepflegte Details verworfen.",
          "logisticTypeCountryOption": "Logistikart & Land",
          "logisticTypeInlineLabel": "Logistikart",
          "schemeInlineLabel": "Schema-ID",
          "dispoInlineLabel": "Dispo-ID",
          "countryInlineLabel": "Land",
          "schemeIdOption": "Schema-ID",
          "dispoIdOption": "Dispo-ID",
          "sendPeriod": "Versandzeitraum",
          "sendPeriodInlineLabel": "Versanddatum",
          "sendOnEachDispo": "Bei jeder Dispo versenden",
          "sendOnChangeDispo": "Bei Änderungen versenden",
          "buttonSaveNewNotification": "Mitteilung anlegen",
          "buttonSaveEditNotification": "Mitteilung speichern",
          "errorSingleFileSelect": "Es muss genau eine PDF-Datei ausgewählt werden.",
          "errorOnlyPdfFileSelect": "Nur PDF-Dateien sind erlaubt."
        },
        "modal": {
          "deleteHeader": "Mitteilungen löschen?",
          "deleteContent": "Sollen die Mitteilungen wirklich gelöscht werden?"
        },
        "deleteErrorMessage": "Mitteilungen konnten nicht gelöscht werden.",
        "deleteSuccessMessage": "Mitteilungen wurden erfolgreich gelöscht.",
        "editErrorMessage": "Mitteilung konnte nicht bearbeitet werden.",
        "editSuccessMessage": "Mitteilung wurde erfolgreich bearbeitet.",
        "createErrorMessage": "Mitteilung konnte nicht angelegt werden.",
        "createSuccessMessage": "Mitteilung wurde erfolgreich angelegt."
      }
    },
    "supplierAssignment": {
      "pageName": "Lieferantenzuordnung Sammellogistik",
      "table": {
        "statusInGateway": "Status in Gateway"
      },
      "details": {
        "table": {
          "header": "Lieferanten",
          "entryPoint": "Eintrittspunkt",
          "supplierId": "Lieferantennr.",
          "supplier": "Lieferant",
          "supplierLocationId": "Standortnr.",
          "supplierLocation": "Standort",
          "travelRoute": "Strecke",
          "vh": "Vorholung",
          "zl": "Zwischenlauf",
          "hl": "Hauptlauf"
        }
      },
      "saveSuccessMessage": "Erfolgreich gespeichert.",
      "saveErrorMessage": "Fehler beim Speichern."
    },
    "dispo": {
      "pageName": "Dispo",
      "tabNames": {
        "all": "Alles",
        "open": "Offen",
        "done": "Erledigt"
      },
      "details": {
        "status": "Status",
        "dispoDesc": "Bezeichnung",
        "dispoId": "Dispo-ID",
        "dispoWeek": "Dispowoche",
        "country": "Empfangsland",
        "freightWeight": "Frachtart",
        "logisticType": "Logistikart",
        "fapArticle": "Aktionsartikel",
        "tabNames": {
          "dispoMonitor": "Dispomonitor",
          "orderMonitor": "Bestellmonitor",
          "statusHistory": "Statushistorie"
        },
        "confirmReleaseToLiaModal": {
          "header": "Dispo wirklich an das Land freigeben?",
          "content": "Achtung, Änderungszeitpunkt 2 ist für diese Dispo bereits überschritten. Bist du sicher, dass du die Dispo an das Land freigeben möchtest?"
        },
        "basicData": "Grunddaten",
        "orderDay": "Abwicklungsrahmen",
        "suppliers": "Lieferanten",
        "basicSettings": "Grundeinstellungen",
        "leadtime": "Erstellvorlauf",
        "resubmission": "Erstellintervall",
        "time": "Zeit",
        "timePeriod": "Zeitraum",
        "deliveryPlanEntry": "Anlieferplan",
        "routeEntry": "Route",
        "loadingCombinationEntry": "Beladekombination",
        "warehouseLabel": "Gesellschaften",
        "combiTourLabel": "Kombitour",
        "wareHouseEntry": "Anlieferung Gesellschaft",
        "hauler": "Spediteur",
        "supplier": "Lieferant",
        "supplierLocation": "Verladestandort",
        "travelRoute": "Strecke",
        "transportType": "Transportart",
        "minOrderVal": "Mindestabnahme",
        "palletType": "Palettenart",
        "settings": "Einstellungen",
        "parameter": "Parameter",
        "weightDispo": "Gewichtsdispo",
        "usePalletTypeHp": "HP berücksichtigen",
        "lorryFlag": "LKW genau",
        "lorryCapacity": "Kapazität in TrM"
      },
      "table": {
        "status": "Status",
        "dispoId": "Dispo-ID",
        "dispoDesc": "Bezeichnung",
        "country": "Empfangsland",
        "dwFrom": "DW von",
        "dwUntil": "DW bis",
        "logisticType": "Logistikart",
        "exception": "Ausnahmen",
        "hasChanges": "Änderung",
        "fapArticle": "Aktionsartikel",
        "orderDate": "Bestelldatum"
      },
      "orderButtonLabel": "Bestellen",
      "releaseToLiaButtonLabel": "Dispo freigeben an LIA ",
      "deleteModalHeader": "Dispo löschen?",
      "deleteModalText": "Soll die Dispo \"[DispoDesc]\" wirklich gelöscht werden?",
      "deleteSuccessMessage": "Dispo \"[DispoDesc]\" wurde erfolgreich gelöscht.",
      "deleteFailedMessage": "Löschen von Dispo \"[DispoDesc]\" ist fehlgeschlagen.",
      "toLiaModalHeader": "Dispofreigabe an LIA",
      "liaReleaseFeedback": {
        "header": " Dispos wurden bearbeitet",
        "success": "Folgende Dispos wurden an LIA freigegeben: ",
        "failed": "Folgende Dispos konnten nicht freigegeben werden: "
      },
      "liaReleaseError": "Die Freigabe an LIA ist fehlgeschlagen",
      "orderModal": {
        "pageName": "Bestellversand: ",
        "buttonOpenNotification": "Mitteilungsboard öffnen",
        "sendHaulerFiles": "Versand Spediteurdatei",
        "sendTms": "TMS Übertrag",
        "switchShowChanges": "Nur offene Bestellungen anzeigen",
        "hasChanges": "Änderungen",
        "tabSupplier": {
          "header": "Bestellungen",
          "supplierName": "Lieferant",
          "supplierLocation": "Standort",
          "contactName": "Kontaktname",
          "contactEmail": "E-Mail",
          "sendType": "Versendet mit",
          "sendDate": "Versendet am",
          "version": "Version",
          "preview": "Vorschau"
        },
        "tabHauler": {
          "transport": "Transport",
          "transportPreCarriage": "Vorholung",
          "transportIntermediate": "Zwischenlauf",
          "transportMainHaulage": "Hauptlauf",
          "header": "Spediteurdateien",
          "partner": "Partner",
          "subject": "Betreff",
          "email": "E-Mail",
          "sendDate": "Versendet am",
          "version": "Version",
          "preview": "Vorschau"
        }
      },
      "dispoMonitor": {
        "editDispoTooltipContent": "Keine Bearbeitung in diesem Status möglich."
      },
      "orderMonitor": {
        "supplierOverview": "Lieferantenübersicht",
        "header": "Partien",
        "headerSl": "Anliefertage",
        "pickUp": "Abholung",
        "deliveryDayHl": "Anliefertag HL",
        "weightDispo": "Gewichtsdispo",
        "lorryFlag": "LKW genau",
        "sumPalSpace": "Summe STP",
        "maxPalSpace": "Max. STP",
        "averagePalSpace": "Aver. STP",
        "averageWeight": "Aver. Gewicht",
        "maxWeight": "Max. Gewicht",
        "lorryCount": "Anzahl TRM",
        "hasChanges": "Änderung",
        "restrictionViolation": "Restriktionsverletzung",
        "restrictionViolations": "Restriktionsverletzungen",
        "warehouse": "Gesellschaft",
        "warehouseShort": "Gesellschaftskürzel",
        "warehouseTableHeader": "Gesellschaften",
        "deliveryDayWarehouse": "Anliefertag GES",
        "deliveryWarehouse": "Anlieferung GES",
        "transportType": "Transportart",
        "invalidSelectionTooltipHeader": "Ungültige Auswahl",
        "invalidSelectionTooltipContent": "Für alle ausgewählten Gesellschaften muss \"Anliefertag GES\" identisch sein.",
        "various": "Div.",
        "loadingCombinationEntry": "Beladekombination",
        "articleLevel": {
          "table": {
            "headline": "Artikel",
            "warehouse": "Gesellschaft",
            "supplier": "Lieferant",
            "supplierLocation": "Verladestandort",
            "travelRoute": "Strecke",
            "networkEntryDate": "Datum Eintritt ins Netzwerk",
            "articleFamily": "Artikelfamilie",
            "articleDesc": "Artikelbezeichnung",
            "gtin": "GTIN",
            "ian": "IAN",
            "colliContent": "Kolliinhalt",
            "palletFactor": "PalF.",
            "weight": "Gewicht",
            "palletType": "Palettenart",
            "palletHeight": "Palettenhöhe",
            "doubleDeckFactor": "Stapelfaktor",
            "orderId": "Bestell-ID",
            "orderPosition": "Bestellposition",
            "orderReference": "Bestellreferenz",
            "lorryNo": "LKW Nummer",
            "orderQuantity": "Bestellmenge"
          }
        },
        "supplierOverviewModal": {
          "orderQuantity": "Bestellmenge",
          "supplierOverview": "Lieferantenübersicht"
        },
        "lorryOverviewModal": {
          "lorryOverview": "Übersicht Transportmittel",
          "warehouse": "Gesellschaft",
          "warehouseShort": "Gesellschaftskürzel",
          "restrictionViolation": "Restriktionsverletzung",
          "lorryNumber": "TrM Nr.",
          "lorryCount": "Anzahl TrM",
          "sumWeight": "Summe Gewicht",
          "maxWeightPerLorry": "Max.Gewicht pro TrM",
          "deltaWeight": "Delta Gewicht",
          "sumPalSpace": "Summe STP",
          "maxPalSpacePerLorry": "Max. STP pro TrM"
        }
      },
      "statusHistory": {
        "taskStatus": "Task Status",
        "taskId": "Task ID",
        "taskMode": "Taskart",
        "created": "Erstellzeitpunkt",
        "closed": "Schließzeitpunkt",
        "taskCategory": "Taskkategorie",
        "notice": "Notiz",
        "taskOpen": "Task öffnen"
      }
    },
    "orders": {
      "pageName": "Bestellungen"
    },
    "send": {
      "food": {
        "pageName": "Versandmonitor Food",
        "pageHeadline": "Versandmonitor Food",
        "tabNames": {
          "order": "Bestellung",
          "hauler": "Spediteur"
        },
        "table": {
          "resend": "Erneut senden",
          "forwardTo": "Weiterleiten an",
          "forwardToCountry": "Weiterleiten an Land",
          "tableConfigHeadline": "Tabelle konfigurieren",
          "headerName": {
            "status": "Status",
            "document": "Dokument",
            "country": "Empfangsland",
            "logisticType": "Logistikart",
            "dispoWeekFrom": "DW von",
            "dispoWeekUntil": "DW bis",
            "businessPartnerId": "Geschäftspartner-ID",
            "businessPartner": "Geschäftpartner",
            "businessPartnerLocation": "Geschäftspartner-Standort",
            "subject": "Betreff",
            "notification": "Mitteilung",
            "primaryContact": "Primärkontakt",
            "contact": "Kontakt",
            "commType": "Versandart",
            "dispoId": "Dispo-ID",
            "orderId": "Bestell-ID",
            "sendDate": "Versanddatum",
            "deliveryDate": "Abrufdatum",
            "taskId": "Task-ID",
            "transferFileId": "System-ID"
          }
        },
        "sidebar": {
          "tabNames": {
            "details": "Details",
            "sendHistory": "Versandhistorie"
          },
          "detailsTabContent": {
            "businessPartnerId": "Geschäftspartner-ID",
            "businessPartnerLocation": "Geschäftspartner-Standort",
            "contact": "Kontakt",
            "dispoId": "Dispo-ID",
            "commType": "Versandart",
            "subject": "Betreff",
            "taskId": "Task-ID",
            "notificationId": "Mitteilungs-ID: {notificationIds}"
          },
          "sendHistoryTabContent": {
            "commType": "Versandart",
            "sentBy": "Versendet durch"
          }
        },
        "forwardToModalDialogue": {
          "radioButton": {
            "label": {
              "mft": "MFT",
              "email": "E-Mail"
            }
          },
          "table": {
            "headerName": {
              "businessPartnerName": "Geschäftspartner",
              "businessPartnerLocation": "Geschäftspartnerstandort",
              "contact": "Kontakt",
              "subject": "Betreff"
            }
          }
        },
        "forwardToCountryModalDialogue": {
          "radioButton": {
            "label": {
              "mft": "MFT",
              "email": "E-Mail"
            }
          },
          "header": {
            "oneCountry": "Weiterleiten an 1 Land",
            "forwardTo": "Weiterleiten an",
            "countries": "Länder"
          }
        }
      },
      "nonfood": {
        "pageName": "Versandmonitor Non Food",
        "pageHeadline": "Versandmonitor Non Food",
        "tabNames": {
          "queryCountry": "Abfrage Land",
          "querySupplier": "Abfrage Lieferant",
          "finalClassification": "Finale Einteilung"
        },
        "table": {
          "resend": "Erneut senden",
          "forwardTo": "Weiterleiten an",
          "tableConfigHeadline": "Tabelle konfigurieren",
          "headerName": {
            "status": "Status",
            "document": "Dokument",
            "businessPartner": "Geschäftpartner",
            "subject": "Betreff",
            "dispoWeek": "Dispowoche",
            "commType": "Versandart",
            "sendDate": "Versanddatum",
            "deliveryDate": "Abrufdatum",
            "transferFileId": "System-ID"
          }
        },
        "sidebar": {
          "tabNames": {
            "details": "Details",
            "sendHistory": "Versandhistorie"
          },
          "detailsTabContent": {
            "advertisingDate": "Liefertermin",
            "businessPartnerId": "Geschäftspartner-ID",
            "businessPartner": "Geschäftspartner",
            "commType": "Versandart",
            "subject": "Betreff",
            "sendDate": "Versanddatum",
            "ians": "IAN"
          },
          "sendHistoryTabContent": {
            "commType": "Versandart",
            "sentBy": "Versendet durch"
          }
        }
      }
    },
    "nonFood": {
      "logisticPlanner": {
        "pageName": "Logistikplaner",
        "processingStatus": {
          "inProgress": "In Bearbeitung",
          "completed": "Abgeschlossen"
        },
        "dispoWeeks": {
          "tabNames": {
            "all": "Alle",
            "inProgress": "In Bearbeitung",
            "completed": "Abgeschlossen"
          },
          "table": {
            "headerName": {
              "dispoWeek": "Dispowoche",
              "createDate": "Erstellzeitpunkt",
              "supplierCount": "Anzahl LFT",
              "countryCount": "Anzahl der Länder",
              "positionCount": "Anzahl Positionen",
              "rmQuerySupplier": "RM für Abfrage LFT",
              "rmQueryCountry": "RM für Abfrage Land",
              "supplierResponse": "Rückmeldung LFT",
              "countryResponse": "Rückmeldung Land",
              "change": "Änderung",
              "optimizationSuggestion": "Optimierungsvorschlag",
              "ordered": "Bestellt",
              "processingStatus": "Bearbeitungsstatus"
            }
          },
          "modalDialogue": {
            "addDispoWeek": {
              "header": "Dispowoche anlegen",
              "dropdown": {
                "countryLabel": "Land",
                "dispoWeekLabel": "Dispowoche",
                "responseDayLabel": "Rückmeldetag"
              },
              "addSuccessMessage": "Folgende Dispowochen wurden hinzugefügt: {weeks}",
              "addErrorMessage": "Dispowochen konnten nicht hinzugefügt werden."
            }
          }
        },
        "dispoWeekDetails": {
          "header": {
            "logisticPlanner": "Logistikplaner",
            "querySupplier": "Abfrage LFT",
            "rmQuerySupplier": "RM Abfrage LFT",
            "queryCountry": "Abfrage Land",
            "rmQueryCountry": "RM Abfrage Land"
          },
          "table": {
            "headline": "Artikel",
            "headerName": {
              "ian": "IAN",
              "articleDesc": "Artikelbezeichnung",
              "deviation": "Abweichungen",
              "supplierDesc": "LFT Bezeichnung",
              "country": "Land",
              "carton": "Krt",
              "rmSupplier": "RM LFT",
              "bmSupplier": "BM LFT",
              "rmCountry": "RM Land",
              "bmCountry": "BM Land",
              "colliContent": "KI",
              "advertisingAppointment": "WT",
              "status": "Status",
              "directDelivery": "Direktbelieferung",
              "cancellation": "Storno",
              "dispoWeekShift": "DW-Verschiebung"
            },
            "validationError": "Direktbelieferung und Storno können nicht gleichzeitig gesetzt werden"
          },
          "buttons": {
            "addCountry": "Land hinzufügen",
            "orderCountry": "Einteilungsversand Land",
            "orderSupplier": "VERSAND MENGENEINTEILUNG LFT"
          },
          "modalDialogue": {
            "addCountryToDispoWeek": {
              "header": "Land hinzufügen",
              "existingCountries": "Bereits vorhanden",
              "dropdown": {
                "countriesToAddLabel": "Weitere Länder hinzufügen"
              }
            },
            "resendRequest": {
              "header": "Bereits versendet",
              "message": "Mindestens ein Empfänger hat die von dir gewählte Abfrage schon erhalten. Möchtest du diese erneut versenden?"
            },
            "sendSupplier": {
              "header": "Versand Mengeneinteilung",
              "switchShowOpenSuppliers": "Nur offene Lieferanten anzeigen",
              "supplier": "Lieferant",
              "preview": "Vorschau",
              "positionReady": "Position bereit",
              "change": "Änderung",
              "sendDate": "Versendet am",
              "toastMessages": {
                "header": "Bestellversand: {dispoWeek}",
                "success": "Es wurden {sumSuccesses} Bestellungen versendet",
                "error": "Es wurden {sumSuccesses} Bestellungen versendet und {sumErrors} Bestellungen konnten nicht versendet werden."
              }
            },
            "sendCountry": {
              "header": "Versand Mengeneinteilung",
              "country": "Land",
              "preview": "Vorschau",
              "positionReady": "Position bereit",
              "change": "Änderung",
              "sendDate": "Versendet am",
              "toastMessages": {
                "header": "Bestellversand: {dispoWeek}",
                "success": "Es wurden {sumSuccesses} Einteilungen versendet",
                "error": "Es wurden {sumSuccesses} Einteilungen versendet und {sumErrors} Einteilungen konnten nicht versendet werden."
              }
            }
          },
          "deviationDeliveryConstellation": "Logistikart fehlt bei IAN"
        },
        "dispoOptimization": {
          "header": {
            "positionFinishedChipLabel": "Optimierung abgeschlossen",
            "itemDesc": "Artikelbezeichnung",
            "supplierDesc": "LFT Bezeichnung",
            "gtin": "GTIN",
            "ekl": "EKL",
            "hauler": "Spediteur",
            "country": "Land",
            "palletFactor": "Palettenfaktor",
            "totalQuantity": "KRT gesamt",
            "palletHeight": "Palettenhöhe",
            "palletWeight": "Palettengewicht",
            "deviationTolerance": "Abweichungstoleranz",
            "distributionType": "Verteilungsart",
            "positions": "{currentPosition}/{maxPosition} Positionen",
            "remainingCartons": "Zu verteilende Kartons",
            "totalPalletStorageSpaces": "{currentPalletStorageSpaces}/{maxPalletStorageSpaces} STP Gesamt",
            "automaticReleaseShipping": "Auto Release Versand",
            "automaticReleaseOptimization": "Auto Release Optimierung",
            "infoTooltipMessage": "Bei aktivem Auto Release wird Optimierung automatisiert durchgeführt"
          },
          "tabNames": {
            "companies": "Gesellschaften",
            "history": "Statushistorie"
          },
          "table": {
            "headline": "Gesellschaften",
            "headerName": {
              "company": "Gesellschaft",
              "actualCarton": "Ist KRT",
              "proposalCarton": "Vorschlag KRT",
              "actualPallet": "Ist PAL",
              "proposalPallet": "Vorschlag PAL",
              "resultPallet": "Ergebnis PAL",
              "targetShare": "Anteil Soll (%)",
              "actualShare": "Anteil Ist (%)",
              "difference": "Differenz (%p)"
            },
            "saveDisabledMessage": "\"Zu verteilende Kartons\" muss 0 sein!",
            "deviationToleranceNotMet": "Die Abweichung liegt außerhalb der Toleranz von {deviationTolerance}.",
            "invalidFormat": "Zahl darf maximal 2 Dezimalstellen haben",
            "toastMessages": {
              "successOnSave": "Anpassung gespeichert",
              "errorOnSave": "Fehler beim Speichern der Anpassung",
              "optimizationCompleted": "Optimierung abgeschlossen",
              "optimizationError": "Optimierung konnte nicht abgeschlossen werden"
            }
          },
          "statusHistory": {
            "headline": "Positionsstatushistorie",
            "statusDescriptions": {
              "add": "Position hinzugefügt",
              "res": "Abfragen versendet",
              "rec": "Abfragen vollständig",
              "opt": "Optimierungsvorschlag liegt vor",
              "rts": "Position versandbereit",
              "rdy": "Position erledigt",
              "chr": "Änderung liegt vor",
              "cha": "Änderung verarbeitet"
            }
          },
          "preOptimizationSaveModalDialogue": {
            "headline": "Speichern",
            "content": "Die Abweichung liegt außerhalb der Toleranz von {deviationTolerance}. Möchtest du wirklich speichern?"
          },
          "finishOptimizationsModalDialogue": {
            "headline": "Optimierungen abschließen?",
            "contentOnSave": "Wenn du fortfährst, werden die Optimierungen abgeschlossen und können nicht mehr bearbeitet werden. Möchtest du dennoch fortfahren?",
            "contentOnOptimization": "Die Kartons für die aktuelle Position sind noch nicht korrekt verteilt (Über- oder Unterverteilung) und werden beim Fortfahren automatisch optimiert. Wenn du fortfährst, werden die Optimierungen abgeschlossen und können nicht mehr bearbeitet werden. Möchtest du dennoch fortfahren?"
          }
        }
      },
      "change": {
        "pageName": "Änderungen",
        "table": {
          "headline": "Änderungen",
          "headerName": {
            "dispoWeek": "Dispowoche",
            "notice": "Notiz",
            "changeCategory": "Änderungskategorie",
            "changeSource": "Änderungsquelle",
            "changeDate": "Änderungsdatum",
            "notificationExisting": "Mitteilung vorhanden",
            "ian": "IAN",
            "articleDesc": "Artikelbezeichnung",
            "action": "Aktion",
            "timeStamp": "Zeitstempel",
            "accept": "Übernehmen"
          }
        },
        "changeCategory": {
          "palFactor": "Palettenfaktor",
          "palWeight": "Palettengewicht",
          "palHeight": "Palettenhöhe",
          "gtin": "GTIN",
          "advertisingDate": "Werbetermin",
          "quantity": "Menge",
          "quantityCarton": "IST_KRT",
          "quantityPercent": "Anteil Soll in %",
          "totalQuantity": "Gesamtmenge",
          "crossdock": "Cross Dock",
          "colliContent": "Kolliinhalt",
          "moveDispoWeek": "Dispowochenverschiebung"
        },
        "changeStatus": {
          "active": "Aktiv",
          "applied": "Übernommen",
          "abandoned": "Verworfen"
        },
        "tab": {
          "open": "Offen",
          "archive": "Archiv"
        },
        "sidebar": {
          "changeCategory": "Änderungskategorie",
          "countries": "Länder",
          "details": "Details",
          "notice": "Notiz",
          "noticeInitial": "Füge eine Notiz hinzu...",
          "notification": "Mitteilung",
          "new": "neu",
          "old": "alt",
          "warehouse": "Gesellschaft"
        },
        "modalDialogueMoveDispoWeeks": {
          "headline": "Dispowochenverschiebung",
          "table": {
            "overview": "Übersicht",
            "dispoWeek": "Dispowoche",
            "ian": "IAN",
            "articleDesc": "Artikelbezeichnung",
            "country": "Land",
            "status": "Status"
          }
        },
        "modalDialogue": {
          "articleDataChangeHeadline": "Artikeldatenänderung anlegen",
          "articleAmountChangeHeadline": "Mengenänderung anlegen",
          "crossdockChangeHeadline": "Cross Dock Änderung anlegen",
          "wizardStep1": "Positionen definieren",
          "wizardStep2": "Änderungen definieren",
          "ian": "IAN",
          "dispoWeek": "Dispowoche",
          "country": "Land",
          "changes": "Änderungen",
          "table": {
            "headline": "Änderungen",
            "headlineWarehouses": "Gesellschaften",
            "changeCategory": "Feld",
            "warehouse": "Gesellschaft",
            "oldValue": "Alt",
            "newValue": "Neu",
            "tooltipHeader": "ACHTUNG:",
            "tooltipContent": "Es liegen abweichende Werte in den selektierten Positionen vor!",
            "invalidPalFactor": "Ungültiger Palettenfaktor",
            "invalidPalWeight": "Ungültiges Palettengewicht",
            "invalidPalHeight": "Ungültige Palettenhöhe",
            "invalidGtin": "Ungültige GTIN",
            "invalidAdvertisingDate": "Ungültiger Werbetermin",
            "invalidCartonValue": "Ungültiger Karton-Wert",
            "invalidPortionValue": "Ungültiger Prozentwert",
            "invalidColliContent": "Ungültiger Kolliinhalt",
            "invalidQuantity": "Ungültige Gesamtmenge"
          }
        },
        "addChangeError": "Beim Speichern der Änderung(en) ist ein Fehler aufgetreten.",
        "addChangeSuccess": "Änderung(en) erfolgreich hinzugefügt.",
        "addNoticeError": "Beim Speichern der Notiz ist ein Fehler aufgetreten.",
        "addNoticeSuccess": "Notiz erfolgreich hinzugefügt.",
        "deleteNoticeError": "Beim Löschen der Notiz ist ein Fehler aufgetreten.",
        "deleteNoticeSuccess": "Notiz erfolgreich gelöscht.",
        "abandonChangeError": "Beim Verwerfen der Änderung ist ein Fehler aufgetreten.",
        "abandonChangeSuccess": "Änderung erfolgreich verworfen.",
        "applyChangeError": "Beim Übernehmen der Änderung ist ein Fehler aufgetreten.",
        "applyChangeSuccess": "Änderung erfolgreich übernommen.",
        "abandonChangeModalDialogue": {
          "headline": "Änderung verwerfen?",
          "infoText": "Bitte füge eine Notiz hinzu.",
          "textAreaLabel": "Notiz",
          "textAreaPlaceholder": "Füge eine Notiz hinzu...",
          "abandonChange": "Änderung verwerfen"
        },
        "applyChangeModalDialogue": {
          "headline": "Möchtest du die Änderung übernehmen?",
          "notice": "Notiz",
          "notification": "Mitteilung",
          "fixQuantities": "Mengen festsetzen",
          "quantityOptimization": "Mengenoptimierung",
          "recalculateQuantities": "Mengenänderung neu rechnen"
        }
      },
      "importFeedBack": {
        "pageName": "Import Rückmeldungen",
        "downloadTemplateCountry": "Download Template Land",
        "downloadTemplateSupplier": "Download Template Lieferant",
        "table": {
          "header": "Übersicht",
          "fileName": "Dateiname",
          "validation": "Validierung"
        },
        "errorMessage": "Folgende Dateien konnten nicht importiert werden: {files}",
        "successMessage": "Dateien wurden erfolgreich importiert"
      }
    },
    "settings": {
      "pageName": "Einstellungen",
      "language": "Sprache",
      "collectionLogistics": "Sammellogistik",
      "directLogistics": "Direktlogistik",
      "modalListHeader": "Grundschema auswählen",
      "schemeParameter": {
        "name": "Schema-Parameter",
        "basicData": {
          "name": "Grunddaten",
          "tableHeadlineBasicData": "Grunddaten",
          "tableHeadlineStackingFactor": "Stapelfaktor"
        },
        "basicSettings": {
          "name": "Grundeinstellungen",
          "tableHeadlineLeadtime": "Erstellvorlauf",
          "tableHeadlineResubmission": "Erstellintervall",
          "tableHeadlineBasicSettings": "Grundeinstellungen",
          "validationErrorMessageValue": "Wert",
          "validationErrorMessageTime": "Zeit ungleich {timeParameterValue} (Systemparameter)"
        },
        "mailSettings": {
          "name": "Versandeinstellungen",
          "tableHeadlineMailSettings": "Versandeinstellungen",
          "tableHeadlineStatusCheck": "Statusprüfung"
        },
        "emailBody": {
          "name": "E-Mail-Body",
          "mailBodyLftInitialSending": "Mailbody LFT - Initialer Versand",
          "mailBodyLftChangeSending": "Mailbody LFT - Änderungsversand",
          "mailBodyLftReminderSending": "Mailbody LFT - Reminder Versand",
          "mailBodyLftNotification": "Mailbody LFT - Mitteilung",
          "mailBodyForward": "Mailbody - Weiterleiten an",
          "mailBodyForwardToCountry": "Mailbody - Weiterleiten an Land",
          "mailBodyForwardToCountryNotCalledUp": "Mailbody - Weiterleiten an Land Nicht Abruf",
          "mailBodySped": "Mailbody SPED",
          "mailBodyHeaderCool": "Kühl",
          "mailBodyHeaderCoolDry": "Kühltrocken",
          "mailBodyHeaderFrozen": "Tiefkühl",
          "mailBodyHeaderDry": "Trocken",
          "mailBodyHeaderUltraFresh": "Ultrafrische",
          "mailBodyHeaderDirectLogistics": "Direktlogistik"
        },
        "bottomBarActions": {
          "cancel": "Abbrechen",
          "transferToSchemas": "Auf Schemas übertragen"
        },
        "transferSuccessMessage": "Die {settings} wurden erfolgreich auf die Schemas übertragen.",
        "transferErrorMessage": "Fehler beim Übertragen der {settings} auf die Schemas.",
        "saveSuccessMessage": "Die Änderungen wurden erfolgreich gespeichert.",
        "saveErrorMessage": "Fehler beim Speichern der Änderungen.",
        "parameter": "Parameter"
      },
      "businessPartner": {
        "name": "Geschäftspartner",
        "table": {
          "businessPartnerId": "Geschäftspartner-ID",
          "businessPartnerDesc": "Geschäftspartnerbezeichnung",
          "businessPartnerShort": "Geschäftspartner-Kürzel",
          "businessPartnerType": "Geschäftspartnertyp",
          "numberOfLocations": "Anzahl Standorte",
          "numberOfContacts": "Anzahl Kontakte",
          "errors": "Fehler",
          "changeDate": "Datum letzte Änderung"
        },
        "details": {
          "businessPartnerId": "Geschäftspartner-ID",
          "businessPartnerDesc": "Geschäftspartnerbezeichnung",
          "businessPartnerType": "Geschäftspartnertyp",
          "numberOfLocations": "Anzahl Standorte",
          "numberOfContacts": "Anzahl Kontakte",
          "gln": "GLN",
          "supplierLocationId": "Standort-ID",
          "supplierLocationDesc": "Standortbezeichnung",
          "supplierLocationType": "Standorttyp",
          "logisticType": "Logistikart",
          "nfExclusions": "Non Food Ausnahmen",
          "nfExclusionTooltip": "Die in diesen Ausnahmen hinterlegten Länder werden nicht über Lidl, sondern von dem Lieferanten selbst beliefert!",
          "editSupplierLocation": "Standort bearbeiten",
          "glnErrorDesc": "Ungültige / fehlende GLN",
          "contacts": {
            "tabName": "Kontakte",
            "successMessage": "Kontakte wurden erfolgreich gespeichert",
            "deletionMessage": "Kontakt wurde erfolgreich entfernt",
            "table": {
              "tableHeader": "Kontakte",
              "tableHeaderModal": "Kontakte bearbeiten",
              "noContactsAvailable": "Keine Kontakte vorhanden",
              "editContacts": "Kontakte bearbeiten",
              "createContactModal": "Kontakt anlegen",
              "noContactsError": "Für diesen Geschäftspartner sind keine Kontakte hinterlegt",
              "contactName": "Kontaktname",
              "contactEmail": "Kontakt",
              "contactCategory": "Kontaktkategorie",
              "validUntil": "Gültig bis",
              "primaryContact": "Primärkontakt",
              "country": "Empfangsland",
              "logisticType": "Logistikart",
              "order": "Bestellung",
              "notification": "Mitteilung",
              "haulerFile": "Spediteurdatei",
              "fapFile": "FAP-Datei",
              "reminder": "Reminder",
              "fwtc": "FWTC",
              "orderNfRequestSupplier": "NF Abfrage",
              "orderNfRequestCountry": "NF Abfrage",
              "orderNf": "NF Einteilung",
              "orderNfClassification": "NF Finale Einteilung",
              "errorMessages": {
                "missingPrimaryContact": "Es existiert kein Primärkontakt.",
                "invalidValue": "Der Wert ist ungültig.",
                "uniqueEmail": "Die Emailadresse muss eindeutig sein.",
                "incompleteContact": "Zeile unvollständig, bitte Dateneingabe prüfen.",
                "missingProcessVariant": "Es wurde keine Prozessvariante ausgewählt.",
                "missingGeneralContactLine": "Keine allgemeingültige Kontaktzeile für [ProcessVariant] vorhanden. Bitte lege zunächst eine solche Zeile an."
              }
            }
          },
          "goodsReceiptTimes": {
            "tabName": "WE-Zeiten",
            "successMessage": "WE-Zeiten wurden erfolgreich gespeichert.",
            "table": {
              "tableHeader": "WE-Zeiten",
              "tableHeaderModal": "Wareneingangszeiten bearbeiten: {SuppLocName}",
              "noDataAvailable": "Keine WE-Zeiten vorhanden",
              "edit": "WE-Zeiten bearbeiten",
              "noGoodReceiptsError": "Für diesen Geschäftspartner sind keine WE-Zeiten hinterlegt",
              "timeRange1": "Zulauf",
              "timeRange2": "Zwischenlauf",
              "timeRange3": "Hauptlauf",
              "timeFrom": "Uhrzeit von",
              "timeUntil": "Uhrzeit bis",
              "errorMessages": {
                "invalidTimeUntil": "\"Uhrzeit bis\" muss nach \"Uhrzeit von\" liegen",
                "invalidTimeFrom2": "\"Uhrzeit von\" des zweiten Zeitraums muss nach \"Uhrzeit bis\" des ersten Zeitraums liegen",
                "invalidTimeFrom3": "\"Uhrzeit von\" des dritten Zeitraums muss nach \"Uhrzeit bis\" des zweiten Zeitraums liegen",
                "requiredTime": "Uhrzeit muss befüllt sein"
              }
            }
          }
        }
      },
      "technicalParameter": {
        "name": "Technische Parameter"
      },
      "userManagement": {
        "name": "Benutzerverwaltung"
      },
      "externalWarehouses": {
        "name": "Außenlager",
        "table": {
          "receivingCountry": "Empfangsland",
          "warehouse": "Gesellschaft",
          "short": "Kürzel",
          "description": "Bezeichnung",
          "zipCode": "Postleitzahl",
          "city": "Stadt",
          "gln": "GLN",
          "extWhId": "ID",
          "addSuccessMessage": "Das Außenlager wurde erfolgreich angelegt.",
          "addErrorMessage": "Die Anlage des Außenlagers ist fehlgeschlagen.",
          "deleteModalHeaderText": "Außenlager löschen?",
          "deleteModalText": "Soll das Außenlager wirklich gelöscht werden?",
          "deleteSuccessMessage": "Das Außenlager wurde erfolgreich gelöscht.",
          "deleteErrorMessage": "Das Löschen des Außenlager ist fehlgeschlagen.",
          "invalidWarehouseShortCombination": "Kürzel wird bereits verwendet."
        }
      },
      "nonFood": {
        "name": "Non-Food",
        "dispoWeeks": {
          "name": "Dispowochen",
          "table": {
            "headline": "Übersicht",
            "parameter": "Parameter",
            "day": "Tag",
            "week": "Woche",
            "time": "Uhrzeit",
            "editSuccessMessage": "Die Änderungen wurden erfolgreich gespeichert.",
            "editErrorMessage": "Die Änderungen konnten nicht gespeichert werden."
          }
        },
        "optimizing": {
          "name": "Optimierung",
          "table": {
            "headline": "Übersicht",
            "country": "Land",
            "crossdock": "Cross-Dock",
            "supplier": "Logistikdienstleister",
            "distributionType": "Verteilungsart",
            "earlySendingOfDistributionInfo": "Abw. Versand FE",
            "deviationTolerance": "Abweichungstoleranz (in %)",
            "autoReleaseOptimizing": "Auto Release Optimierung",
            "autoReleaseSend": "Auto Release Versand",
            "buttonCreateCountry": "Land anlegen",
            "addSuccessMessage": "Das Land wurde erfolgreich angelegt.",
            "addErrorMessage": "Die Anlage des Landes ist fehlgeschlagen.",
            "buttonEditCountry": "Land bearbeiten",
            "editSuccessMessage": "Die Änderungen wurden erfolgreich gespeichert.",
            "editErrorMessage": "Die Änderungen konnten nicht gespeichert werden.",
            "deleteModalHeaderText": "Optimierung löschen?",
            "deleteModalText": "Soll die Optimierung wirklich gelöscht werden?",
            "deleteSuccessMessage": "Die Optimierung wurde erfolgreich gelöscht.",
            "deleteErrorMessage": "Das Löschen der Optimierung ist fehlgeschlagen.",
            "invalidDeviationToleranceFormat": "Zahl muss zwischen 0 und 100 mit maximal 1 Nachkommastelle liegen",
            "invalidEntry": "Die Kombination Land Cross-Dock muss eindeutig sein"
          },
          "modalDialogue": {
            "name": "Gesellschaften",
            "invalidElmSchemeId": "Die ELM-Schema-ID muss aus 1-6 Ziffern bestehen",
            "invalidReference": "Die Fixangabe Referenz muss aus 1-5 Zeichen bestehen",
            "table": {
              "headerName": {
                "warehouse": "Gesellschaft",
                "warehouseShort": "Gesellschaftskürzel",
                "rank": "Rang",
                "elmSchemeId": "ELM-Schema-ID",
                "reference": "Fixangabe Referenz",
                "partReferenceCalculation": "Variabler Teil Referenz Berechnung",
                "partDeliveryFrom": "Variabler Teil Anlieferung von",
                "partDeliveryUntil": "Variabler Teil Anlieferung bis"
              }
            }
          }
        },
        "emailBody": {
          "name": "Non Food E-Mail-Body",
          "mailBodyLftNonFoodInitialSending": "Mailbody LFT - Verbindliche Mengeneinteilung",
          "mailBodyLftNonFoodChangeSending": "Mailbody LFT - Änderung Verbindliche Mengeneinteilung",
          "mailBodyCountryNonFoodOrderInformation": "Mailbody Land - Finale Einteilung",
          "mailBodyCountryChange": "Mailbody Land - Änderung Finale Einteilung",
          "mailBodyLftNonFoodRequest": "Mailbody LFT - NF Abfrage",
          "mailBodyCountryNonFoodRequest": "Mailbody Land - NF Abfrage",
          "mailBodyHeaderNonFood": "Non Food",
          "saveSuccessMessage": "Die Änderungen wurden erfolgreich gespeichert.",
          "saveErrorMessage": "Fehler beim Speichern der Änderungen."
        },
        "externalWarehouses": {
          "name": "Non Food Außenlager"
        }
      }
    },
    "system": {
      "pageName": "System",
      "roles": {
        "name": "Rollen",
        "table": {
          "roleShort": "Rolle",
          "roleDesc": "Rollenbeschreibung",
          "siamKey": "SIAM Schlüssel",
          "createDate": "Datum Erstellung",
          "changeDate": "Datum letzte Änderung"
        },
        "createRoles": {
          "name": "Rolle anlegen",
          "placeholderRoleDesc": "Rollenbeschreibung zur besseren Unterscheidung",
          "validation": {
            "mandatoryFieldErrorMessage": "Pflichtfeld",
            "roleExistsErrorMessage": "Rolle exisiert bereits",
            "siamKeyExistsErrorMessage": "SIAM Schlüssel wird bereits verwendet"
          },
          "saveErrorMessage": "User-Rolle konnte nicht angelegt werden.",
          "saveSuccessMessage": "User-Rolle erfolgreich angelegt."
        },
        "editRoles": {
          "name": "Rolle bearbeiten",
          "cancelEditModaldialogue": {
            "headline": "Änderungen verwerfen?",
            "message": "Sollen die Änderungen wirklich verworfen werden?"
          },
          "deleteModaldialogue": {
            "headline": "Rolle löschen?",
            "message": "Bitte vergewissere dich in SIAM, dass die Rolle keinem User mehr zugeordnet ist."
          },
          "updateErrorMessage": "Die Änderungen konnten nicht gespeichert werden.",
          "updateSuccessMessage": "Die Änderungen wurden erfolgreich gespeichert.",
          "deleteErrorMessage": "Die Rolle konnte nicht gelöscht werden.",
          "deleteSuccessMessage": "Die Rolle wurde gelöscht."
        }
      },
      "permissions": {
        "name": "Berechtigungen",
        "functionColumnHeader": "Funktion",
        "saveSuccessMessage": "Die Änderungen wurden erfolgreich gespeichert.",
        "saveErrorMessage": "Die Änderungen konnten nicht gespeichert werden."
      },
      "reports": {
        "name": "Berichte",
        "executeReport": "Bericht ausführen",
        "tileName": {
          "reimbursementDL": "Rückvergütung Direktlogistik"
        },
        "modalDialogue": {
          "dropdown": {
            "countryLabel": "Land",
            "haulerLabel": "Spediteur",
            "supplierLabel": "Lieferant"
          },
          "radioButton": {
            "daySpecificLabel": "Taggenau",
            "weekSpecificLabel": "Wochengenau"
          },
          "calendar": {
            "placeholder": "Zeitraum",
            "calendarWeekLabel": "KW"
          },
          "weekSpecificDropdown": {
            "weekFromLabel": "KW von",
            "weekUntilLabel": "KW bis"
          }
        }
      },
      "newsAdministration": {
        "name": "News-Verwaltung"
      },
      "parameters": {
        "technicalName": "Technische Parameter",
        "businessName": "Fachliche Parameter",
        "table": {
          "category": "Kategorie",
          "header": "Parameter",
          "description": "Bezeichnung",
          "input": "Eingabe"
        }
      },
      "manualCalls": {
        "emergencyImport": "Notfallimport LIA:",
        "emergencyImportSuccessMessage": "Der Notfallimport war erfolgreich.",
        "emergencyImportErrorMessage": "Fehler beim Notfallimport:\nFolgende Dateien liefen auf Fehler: {errorFiles}\nFolgende Dateien waren erfolgreich: {successFiles}",
        "name": "Manuelle Aufrufe",
        "kolibri": "Manuelles Senden der Kolibri Daten:",
        "kolibribtn": "Kolibri Daten senden",
        "saveKolibriSuccessMessage": "Das Senden der Kolibri Daten wurde erfolgreich durchgeführt.",
        "saveKolibriErrorMessage": "Fehler beim Senden der Kolibri Daten. Für Details siehe Logging-Tabelle.",
        "eksImport": "Manuelles Importieren der EKS Daten:",
        "eksImportbtn": "EKS Daten importieren",
        "saveEksImportSuccessMessage": "Das Importieren der EKS Daten wurde angestoßen.",
        "saveEksImportErrorMessage": "Fehler beim Anstoßen des EKS Imports. Für Details siehe Logging-Tabelle."
      },
      "loggings": {
        "name": "Log-Tabelle",
        "headline": "Einträge",
        "table": {
          "logId": "Id",
          "logTime": "Zeitpunkt",
          "logLevel": "Ebene",
          "context": "Kontext",
          "message": "Meldung",
          "key": "Schlüssel",
          "callstack": "Callstack",
          "info": "Info",
          "logUser": "Benutzer"
        }
      },
      "ediErrors": {
        "name": "EDI Fehler",
        "table": {
          "createDate": "Fehlerdatum",
          "category": "Kategorie",
          "errorMessage": "Fehlerbeschreibung",
          "sendDate": "Versanddatum Fehlerbericht",
          "dispoId": "Dispo-ID",
          "dispoDesc": "Dispobezeichnung",
          "haulerName": "Spediteur",
          "haulerId": "Spediteur-ID",
          "haulerLocation": "Standortname",
          "haulerLocationId": "Standort-ID",
          "supplierName": "Lieferant",
          "supplierId": "Lieferanten-ID",
          "supplierLocation": "Standortname",
          "supplierLocationId": "Standort-ID",
          "validFrom": "Gültig ab",
          "supplierGln": "GLN Lieferant",
          "supplierLocationType": "Standorttyp",
          "country": "Empfangsland",
          "itemIdInt": "IAN",
          "shortDescInt": "Int. Artikelbezeichnung",
          "itemIdNat": "NAN",
          "shortDescNat": "Nat. Artikelbezeichnung",
          "ediErrorSource": "Fehlerquelle"
        }
      },
      "fileTransferErrors": {
        "name": "Vorversand Fehler",
        "table": {
          "tableHeader": "Einträge",
          "dispoId": "Dispo-ID",
          "dispoDesc": "Dispobezeichnung",
          "businessPartnerDesc": "Geschäftspartner",
          "businessPartnerLocation": "Standort",
          "contact": "Kontakt",
          "commTypeDesc": "Versandart",
          "messageDate": "Nachrichtendatum",
          "taskId": "Task-ID"
        }
      },
      "scheduler": {
        "name": "Scheduler-Tabelle",
        "tableHeadline": "Jobs",
        "table": {
          "date": "Datum",
          "lastRun": "Letzter Aufruf",
          "nextRun": "Nächster Aufruf",
          "running": "Aktiv",
          "task": "Aufgabe",
          "time": "Uhrzeit"
        }
      },
      "dispoImport": {
        "name": "Dispo Import",
        "loadingText": "Dispo Import läuft ...",
        "errorMessage": "Die Dispo konnte nicht importiert werden. Für Details siehe Logging-Tabelle",
        "successMessage": "Die Dispo wurde erfolgreich importiert: Neue DispoID: {dispoId}"
      },
      "systemInfo": {
        "name": "System-Info",
        "titleGateway": "Info zu Gateway",
        "titleDatapool": "Info zu Datapool",
        "frontend": "Frontend",
        "from": "vom"
      }
    },
    "error": {
      "error": "Error",
      "unauthorized": {
        "withGatewayRole": {
          "headline": "Ups, sieht aus als könnte die Seite nicht angezeigt werden.",
          "checkPermissionMessage": "Vergewissere dich, dass du eine Berechtigung für den Bereich hast."
        },
        "withoutGatewayRole": {
          "headline": "Ups, sieht so aus als hättest du keine Zugriffserlaubnis.",
          "siamPortalMessage": "Öffne das SIAM Portal, um den Zugriff zu beantragen.",
          "openSiamButtonLabel": "SIAM öffnen"
        }
      },
      "notFound": {
        "headline": "Ups, die Seite konnte nicht gefunden werden.",
        "checkLinkMessage": "Vergewissere dich, dass der korrekte Link verwendet wird."
      },
      "unknown": {
        "headline": "Ups, sieht aus als könnte die Seite nicht angezeigt werden.",
        "message": "Es ist ein unbekannter Fehler aufgetreten."
      }
    },
    "logout": {
      "success": "Abmeldung erfolgreich",
      "login": "Erneut anmelden"
    }
  }
}
